<app-partner-registration-form #partnerRegistrationForm (eventRegister)="onRegister()" (eventBack)="onBack()" (eventLogin)="onLogin()"></app-partner-registration-form>
